<template>
  <div class="expertSettings">
    <table class="expertSettings__data">
      <template
        v-if="$store.getters.iotDeviceId.toLowerCase().indexOf('none') === -1"
      >
        <tr>
          <td>Aktuelle Zählermessung und Funkqualität</td>
          <td>
            <a
              :href="
                'https://' +
                $store.getters.iotDeviceId +
                '.balena-devices.com/setup'
              "
              target="_blank"
              class="expertSettings__link"
              >eFriends Meter Setup <IconExternal
            /></a>
          </td>
        </tr>
        <tr>
          <td>Cube neu starten</td>
          <td>
            <a
              @click="restartCube()"
              style="cursor: pointer"
              target="_blank"
              class="expertSettings__link"
              id="expertSettings__restartButton"
              >Restart <IconExternal
            /></a>
            <span
              id="expertSettings__hiddenLabel"
              style="visibility: hidden; display: none"
              >Restart läuft ...</span
            >
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <em
              >Falls der Cube Verbindungen verliert oder andere
              Störungsanzeichen vorhanden sind, kann der Cube über diesen Link
              neu gestartet werden. Ein Restart dauert rund 3 Minuten.</em
            >
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="2">
            <em>Keine Experten-Einstellungen verfügbar.</em>
          </td>
        </tr>
      </template>
    </table>
  </div>
</template>

<script>
  import IconExternal from '@/components/icons/External'

  export default {
    name: 'expertSettings',
    components: {
      IconExternal,
    },
    methods: {
      restartCube: function () {
        this.$store.dispatch('restartCube')
        document.getElementById('expertSettings__restartButton').style.display =
          'none'
        document.getElementById(
          'expertSettings__restartButton'
        ).style.visibility = 'hidden'

        document.getElementById('expertSettings__hiddenLabel').style.display =
          'block'
        document.getElementById(
          'expertSettings__hiddenLabel'
        ).style.visibility = 'visible'

        setTimeout(function () {
          document.getElementById(
            'expertSettings__restartButton'
          ).style.display = 'block'
          document.getElementById(
            'expertSettings__restartButton'
          ).style.visibility = 'visible'

          document.getElementById('expertSettings__hiddenLabel').style.display =
            'none'
          document.getElementById(
            'expertSettings__hiddenLabel'
          ).style.visibility = 'hidden'
        }, 180000)
      },
    },
  }
</script>

<style lang="scss">
  .expertSettings {
    &__data {
      border: 1px solid $grey-light;
      border-collapse: collapse;
    }

    &__link {
      font-size: $font-size-lg;
      color: $body-color;
      transition: $transition-base;

      .icon {
        width: 1em;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
</style>
